import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  style?: any;
}

export const Root = styled.div`
  z-index: 200;
  position: fixed;
  bottom: 20px;
  right: 20px;
  justify-content: center;
  align-items: center;
  .group-snack-list{
    display: flex;
    flex-direction: column-reverse;
  }
`

export const SnackbarBox = styled.div`
  position: relative;
  width: calc(400px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  margin-bottom: 5px;
  color: ${(props: IRootProps) => (props.style?.color ? props.style.color : C.WHITE)};
  background-color: ${(props: IRootProps) => (props.style?.backgroundColor ? props.style.backgroundColor : C.DARK_BLUE)};
  border-radius: 6px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12);
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
`

export const MessageContainer = styled.div`
  width: 321px;
  padding-right: 10px;
  flex-wrap: wrap;
  overflow: hidden;
  font-family: Roboto;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
`

export const ActionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  background-color: rgba(0, 0, 0, 0);
  cursor: pointer;
  &:hover {
    background-color: #FFFFFF66;
  }
`
